/**
 * Shared response shape for /auth/login and /auth/refresh — both return
 * { accessToken, tokenType, userId, username }. Kept dependency-free (no
 * axios/http import) so both authApi.ts and http.ts can parse into it
 * without creating a circular import between those two modules.
 */
import { extractUserIdFromAccessToken } from './jwt';

export interface AuthResult {
  accessToken: string;
  tokenType: string;
  username: string;
  userId: string | null;
}

export function parseAuthResponse(payload: unknown, fallbackUsername = ''): AuthResult | null {
  if (!payload || typeof payload !== 'object') return null;
  const record = payload as Record<string, unknown>;
  const accessToken =
    (typeof record.accessToken === 'string' && record.accessToken) ||
    (typeof record.access_token === 'string' && record.access_token) ||
    null;
  if (!accessToken) return null;
  const tokenType =
    (typeof record.tokenType === 'string' && record.tokenType) ||
    (typeof record.token_type === 'string' && record.token_type) ||
    'bearer';
  const username =
    (typeof record.username === 'string' && record.username.trim() && record.username) ||
    fallbackUsername;
  const userId =
    (typeof record.userId === 'string' && record.userId.trim() && record.userId) ||
    (typeof record.user_id === 'string' && record.user_id.trim() && record.user_id) ||
    extractUserIdFromAccessToken(accessToken);
  return { accessToken, tokenType, username, userId };
}
